import FluxCredit from './flux-credit.svg';
import FluxLogo from './flux-logo.svg';
import FluxPlusLogo from './flux-plus-logo.svg';
import FluxPlus from './flux-plus.svg';

export default {
  FluxCredit,
  FluxLogo,
  FluxPlus,
  FluxPlusLogo,
};
